export enum WorkingHoursType {
    REGULAR = 'Regular',
    FLATRATE = 'FlatRate'
}
